import { useContext } from 'react';
import { useInterpret } from '@xstate/react';

import { DataAccessContext } from '@chargify/data-access';

import { PaymentProfilesContext } from '../contexts';
import { deletePaymentProfile } from '../machines/deletePaymentProfile';

type Options = {
  paymentProfileId: number;
  onDeleteSuccess: () => void;
};
/**
 * Configures machine responsible for delete payment profile
 * @param {number} paymentProfileId - payment profile identifier
 * @param {() => void} onChangeSuccess - callback to be called when payment profile is created
 * @returns {Record} payment profile delete service
 */
export const useDeletePaymentProfile = ({
  paymentProfileId,
  onDeleteSuccess,
}: Options) => {
  const { dataAccess } = useContext(DataAccessContext);
  const { paymentProfilesService } = useContext(PaymentProfilesContext);

  return useInterpret(deletePaymentProfile, {
    actions: {
      onDeleteProfileSuccess: () => {
        paymentProfilesService.send({
          type: 'DELETE_PAYMENT_PROFILE',
          paymentProfileId,
        });
        onDeleteSuccess();
      },
    },
    services: {
      deletePaymentProfile: () => {
        return dataAccess.deletePaymentProfile(paymentProfileId);
      },
    },
  });
};
